module.exports = __webpack_public_path__ + "static/media/The Mall c. 1950s.1a71fa14.jpg";